import React from 'react';
import { motion } from 'framer-motion';
import { Heart, X } from 'lucide-react';
import { SectionEyebrow } from './SectionEyebrow';
import { CTAButton } from './CTAButton';
export function QueHaceDiferente() {
  return <section className="py-24 md:py-32 px-6 bg-background" data-id="element-192">
      <div className="container max-w-[1000px] mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-194">
          <SectionEyebrow text="La diferencia" className="mb-6" data-id="element-195" />
          <h2 className="text-4xl md:text-5xl text-foreground" data-id="element-196">
            No es un libro más,{' '}
            <span className="italic text-muted-foreground" data-id="element-197">es un proceso</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-198">
          {/* Esto NO es */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-card/50 p-8 md:p-12 rounded-2xl border border-border/40 opacity-80" data-id="element-199">
            <h3 className="font-serif text-2xl text-muted-foreground/70 mb-8 text-center italic" data-id="element-200">
              Esto NO es...
            </h3>
            <ul className="space-y-6" data-id="element-201">
              {['Motivación vacía que se desvanece al día siguiente', 'Autoayuda genérica sin pasos aplicables', 'Frases bonitas sin profundidad ni transformación real'].map((item, i) => <li key={i} className="flex items-start gap-4 text-muted-foreground/70 font-light" data-id="element-202">
                  <X className="w-5 h-5 text-muted-foreground/40 shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-203" />
                  <span data-id="element-204">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Esto SÍ es */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-card p-8 md:p-12 rounded-2xl shadow-soft border border-accent/20" data-id="element-205">
            <h3 className="font-serif text-2xl text-foreground mb-8 text-center" data-id="element-206">
              Esto SÍ es...
            </h3>
            <ul className="space-y-6" data-id="element-207">
              {['Una experiencia femenina de sanación profunda', 'Práctica y emocional, con ejercicios reales', 'Espiritual y con los pies en la tierra', 'Bellamente diseñada y profundamente intencional', 'Premium y verdaderamente transformadora'].map((item, i) => <li key={i} className="flex items-start gap-4 text-foreground font-light" data-id="element-208">
                  <Heart className="w-5 h-5 text-accent shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-209" />
                  <span data-id="element-210">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="flex justify-center mt-16" data-id="element-211">
          <CTAButton text="Quiero vivir esta experiencia" data-id="element-212" />
        </div>
      </div>
    </section>;
}